import React from 'react';
import {connect} from "react-redux";
import {ACTION_SET_AUTH_USER, ACTION_SET_SELECTED_UNIT, ACTION_SET_UNITS} from "../reducers/constants";
import {auth} from "../firebase";
import {clearAllNotifications} from "./notifications/live";

/**
 * HOC component to properly sign out user and clear persisted states held in Redux when signed out.
 * @param Component to be rendered
 */
const withSignOut = (Component) => {
    class WithSignOut extends React.Component {
        componentWillMount() {
            // Do sign out once more just in case
            auth.doSignOut();
            // Clear states from Redux store
            this.props.onSetAuthUser(null);
            this.props.onSetUnits({});
            this.props.onSetSelectedUnit(null);
            clearAllNotifications();
        }

        render() {
            return <Component/>;
        }
    }

    /**
     * Map Redux {@param dispatch} a.k.a. actions to component props
     */
    const mapDispatchToProps = (dispatch) => ({
        onSetAuthUser: (authUser) => dispatch({type: ACTION_SET_AUTH_USER, authUser}),
        onSetUnits: (units) => dispatch({type: ACTION_SET_UNITS, units}),
        onSetSelectedUnit: (selectedUnit) => dispatch({type: ACTION_SET_SELECTED_UNIT, selectedUnit})
    });

    return connect(null, mapDispatchToProps)(WithSignOut)
};

export default withSignOut;



// WEBPACK FOOTER //
// ./src/components/WithSignOut.jsx